import {
  Box,
  Card,
  CardActionArea,
  CardMedia,
  Grid,
  Typography,
} from "@mui/material";
import { FC } from "react";
import { useNavigate } from "react-router";
import { iCategoria } from "../../data/categorias";
import { useActividadesContext } from "./Hook/useActividades";

const CategoriaCard: FC<iCategoria> = ({
  label,
  descripcion,
  img,
  alt,
  route,
  backgroundColor,
  borderColor,
}) => {
  const navigate = useNavigate();
  const { changeApp } = useActividadesContext();

  const handleChange = () => {
    changeApp(null);
    navigate(`/asistente/${route}`);
  };

  return (
    <Card
      sx={{
        width: "100%",
        borderRadius: "15px",
        transition: "transform 0.05s ease-in-out, box-shadow 0.3s ease-in-out",
        ":hover": {
          transform: "scale(1.00)",
          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.3)",
        },
        position: "relative",
        zIndex: 1,
        borderBottom: 10,
        borderBottomLeftRadius: 30,
        borderBottomRightRadius: 30,
        borderColor: borderColor,
      }}
    >
      <CardActionArea onClick={handleChange}>
        <Box sx={{ position: "relative", width: "100%", height: "200px" }}>
          <CardMedia
            component="img"
            image={img}
            alt={alt}
            sx={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
            }}
          />
        </Box>
        <Grid
          sx={{
            width: "100%",
            backgroundColor: backgroundColor,
            display: "flex",
            flexDirection: "column",
            px: { xs: 1, md: 2 },
            py: 2,
          }}
        >
          <Typography
            variant="h6"
            fontFamily="Montserrat"
            color="#336B87"
            fontWeight="bold"
            sx={{ fontSize: { xs: "1.1rem", sm: "1.25rem" } }}
          >
            {label}
          </Typography>
          <Typography
            variant="body2"
            fontFamily="Montserrat"
            color="rgba(0, 0, 0, 0.6)"
            sx={{ fontSize: { xs: "0.9rem", sm: "1rem" } }}
            fontWeight={"medium"}
          >
            {descripcion}
          </Typography>
        </Grid>
      </CardActionArea>
    </Card>
  );
};

export default CategoriaCard;
